import React, { useContext } from "react";
import AppContext from "../../util/AppContext";

import './Gotqueries.css';

const GotQueries = () => {
  const myContext = useContext(AppContext);

  React.useEffect(() => {
    const ele = document.getElementsByClassName('gotqueries')[0];
    myContext.setGotQueriesHeight(ele.offsetHeight);
    console.log(ele.offsetHeight);
  }, [])

  return (
    <div className="gotqueries">
      <a
        href="/form"
        style={{
          color: "white",
        }}
      >
        got queries? get in touch with us
      </a>
    </div>
  );
};

export default GotQueries;
